import { BOE_PROGRAM_DOC_IDS, PROGRAM_CONFIG, MONEY_BLOCKS } from '../../../shared/constants/programBudget';
import { sumSectionTotals } from '../../../budget/utils/programBudgetUtils';

export function buildBoeOverview(documents, year, type) {
  const programs = BOE_PROGRAM_DOC_IDS.map(id => ({
    id, label: PROGRAM_CONFIG.find(config => config.key.startsWith(`${id} `))?.label.replace(/^\d+\s+/, '') || id,
    value: sumSectionTotals(documents[id]?.[year]?.[type]),
  }));
  const complete = programs.every(program => program.value !== null);
  const total = complete ? programs.reduce((sum, program) => sum + program.value, 0) : null;
  return { complete, total, programs };
}

export function boeOverviewOptions(documents) {
  const years = [...new Set(Object.values(documents).flatMap(data => Object.keys(data).filter(key => /^\d{4}$/.test(key))))].map(Number).sort((a,b) => b-a);
  return years.flatMap(year => ['Approved', 'Proposed'].filter(type => buildBoeOverview(documents,year,type).complete).slice(0,1).map(type => ({ year,type })));
}

export function boeCostBreakdown(documents, year, type) {
  const rows = MONEY_BLOCKS.map(block => {
    const values = BOE_PROGRAM_DOC_IDS.map(id => {
      const entries = Object.entries(documents[id]?.[year]?.[type]?.[block] || {}).filter(([key]) => !/^total$/i.test(key));
      return entries.reduce((sum,[,value]) => sum + (typeof value === 'number' && Number.isFinite(value) ? value : 0), 0);
    });
    return { id:block, label:block, value:values.reduce((sum,value) => sum+value,0) };
  });
  return rows;
}
